import React, { Component } from 'react';
import { connect } from 'react-redux';
import {toastr} from 'react-redux-toastr';

import Layout from '../components/Layout';

import { changePassword } from '../actions/Perfil';
import { pwStrong } from '../services/functions';

class Profile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            passCurrent: '',
            passNew: '',
            passConfirm: ''
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePassConfirm = this.handlePassConfirm.bind(this);
        this.handlePassNew = this.handlePassNew.bind(this);
        this.handlePassCurrent = this.handlePassCurrent.bind(this);
    }

    async handleSubmit(event) {
        event.preventDefault();

        if(this.state.passNew!==this.state.passConfirm) {
            toastr.warning(' Senha de confirmação não confere! ');
            return;
        }

        if(!pwStrong(this.state.passNew)){
            toastr.warning(' Sua senha precisa de 6 à 20 caracteres entre maiuscula, minuscula e caracteres "[, @, !, #, $, *, _, - e]" ');
            return;
        }

        this.props.changePassword(this.state);
    }

    handlePassConfirm(event) {
        this.setState({passConfirm: event.target.value});
    }
    handlePassNew(event) {
        this.setState({passNew: event.target.value});
    }
    handlePassCurrent(event) {
        this.setState({passCurrent: event.target.value});
    }
    
    render() { 
        return (
            <Layout>
                <section className="content-header">
                    <h1>
                        Perfil
                    </h1>
                    <ol className="breadcrumb">
                        <li><a href="#"  onClick={() => {}}><i className="fa fa-dashboard"></i> Home</a></li>
                        <li className="active">Perfil usuário</li>
                    </ol>
                </section>

                <section className="content">
        
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box box-info">
                                <div className="box-header with-border">
                                    <h3 className="box-title"><b>Usuário</b></h3>
                                </div>

                                <div className="box-body">
                                    <div className="offset-md-3 col-md-6">  
                                        <h3>Alterar senha </h3>
                                    
                                        <form className="form-horizontal" onSubmit={ this.handleSubmit }>
                                            <div className="box-body">

                                                <div className="form-group">
                                                    <label htmlFor="passCurrent" className="col-sm-6 control-label">Senha atual</label>

                                                    <div className="col-sm-12">
                                                        <input type="password" 
                                                            className="form-control" 
                                                            id="passCurrent" 
                                                            value={this.state.passCurrent} 
                                                            onChange={ this.handlePassCurrent }
                                                            placeholder="Senha atual" 
                                                            required />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="newPassword" className="col-sm-6 control-label">Nova senha</label>

                                                    <div className="col-sm-12">
                                                        <input type="password" 
                                                            className="form-control" 
                                                            id="newPassword" 
                                                            autoComplete="new-password" 
                                                            value={this.state.passNew} 
                                                            onChange={ this.handlePassNew }
                                                            placeholder="Nova Senha" 
                                                            required />
                                                    </div>
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="confirmPassword" className="col-sm-6 control-label">Nova senha</label>

                                                    <div className="col-sm-12">
                                                        <input type="password" 
                                                            className="form-control" 
                                                            id="confirmPassword" 
                                                            autoComplete="new-password" 
                                                            value={this.state.passConfirm} 
                                                            onChange={ this.handlePassConfirm }
                                                            placeholder="Confirmar senha" 
                                                            required />
                                                    </div>
                                                </div>
                                            
                                            </div>
                                            <div className="box-footer">
                                                <button type="submit" className="btn btn-info pull-right">Alterar</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
        );
    }
}

const mapStateToProps = state => {

    return (
    {
        auth: state.AutenticacaoReducer,
    }
)}
  
  
export default connect(mapStateToProps, { changePassword })(Profile);
